import React from 'react'

function GrayLine() {
  return (
    <div className=' w-full h-[1px] bg-gray-100 '></div>
  )
}

export default GrayLine